module.exports = __webpack_public_path__ + "static/media/spicy-piri-test-dt.fae0b547.jpg";